/* eslint-disable camelcase */

import {ISimpleSubProduct, ISimpleSubRcVariantMap} from '../types';

const getRcDiscountedPrice = (product: ISimpleSubProduct): number => {
  const variantMap: ISimpleSubRcVariantMap = product?.originalToHiddenVariantMap;
  const mappedVariant: ISimpleSubRcVariantMap = variantMap?.[product.selectedVariantId];
  const discountedPriceStr: string = mappedVariant?.discount_variant_price;

  if (discountedPriceStr) {
    return parseInt(discountedPriceStr.replace('.', ''));
  }

  return null;
};

export default getRcDiscountedPrice;